module.exports = __webpack_public_path__ + "media/player_win.b8ee461b.mp3";